module.exports = __webpack_public_path__ + "static/media/personality1.c40ccaea.jpeg";